// Utility functions for transfer bid validation
// --------------------------------------------
// Centralised here so both TransfersPage and PlayerPage pop-ups can share the same logic.

// Hard-coded step used for the numeric bid <input>
export const BID_STEP = 100_000; // €100k per step
export const MIN_TRANSFER_AMOUNT = 1;

const toFiniteNumberOrNull = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

// Check that the proposed bid "amount" (in full euros) exceeds the auction's current price.
export const isBidValid = (amount, currentPrice = 0) => {
  const amt = toFiniteNumberOrNull(amount);
  const cp = toFiniteNumberOrNull(currentPrice);
  if (amt === null || cp === null) return false;
  return amt >= MIN_TRANSFER_AMOUNT && amt > cp;
};

// Derive the minimum legal bid for the next offer based on status/current price.
export const computeNextMinimumBid = ({ isFreeAgent, marketValue, currentPrice }) => {
  const safeMarket = Number.isFinite(marketValue) ? marketValue : 0;
  const hasCurrentPrice = Number.isFinite(currentPrice);
  const nextAboveCurrent = hasCurrentPrice ? currentPrice + 1 : 1;

  if (isFreeAgent) {
    return Math.max(safeMarket, nextAboveCurrent, MIN_TRANSFER_AMOUNT);
  }

  return MIN_TRANSFER_AMOUNT;
};

export const computeCounterOfferLimits = ({
  isFreeAgent,
  marketValue,
  currentAmount,
  isBuyer,
  reservedAmount = 0,
  remainingBudget = null
}) => {
  const current = toFiniteNumberOrNull(currentAmount) ?? 0;
  const market = toFiniteNumberOrNull(marketValue) ?? 0;
  const reserved = toFiniteNumberOrNull(reservedAmount) ?? 0;
  const remaining = toFiniteNumberOrNull(remainingBudget);
  const buyerBudgetCap = remaining === null ? null : remaining + reserved;

  if (isFreeAgent) {
    return {
      min: Math.max(market, current + 1, MIN_TRANSFER_AMOUNT),
      max: buyerBudgetCap,
      direction: 'higher'
    };
  }

  if (isBuyer) {
    const directionCap = Math.max(current - 1, 0);
    return {
      min: MIN_TRANSFER_AMOUNT,
      max: buyerBudgetCap === null ? directionCap : Math.min(directionCap, buyerBudgetCap),
      direction: 'lower'
    };
  }

  return {
    min: Math.max(current + 1, MIN_TRANSFER_AMOUNT),
    max: null,
    direction: 'higher'
  };
};
